window.NPS = window.NPS || {};
window.NPS.Views = window.NPS.Views || {};
window.NPS.Views.LinkEdit = window.NPS.Views.LinkEdit || {};
window.NPS.Views.LinkEdit.Views = window.NPS.Views.LinkEdit.Views || {};
window.NPS.Views.LinkEdit.Views['select/module'] = (function($, _) {

    function view(editor, opts) {
        var
            self = this,
            opts = _.defaults({}, opts)
        ;
        this.editor = editor;
        this.$el = editor.$el.find('[data-page]');
        this.link = editor.link;
        this.opts = opts;

        this.$selection = null;
    }

    view.prototype.$ = function (sp) {
        return this.$el.find(sp);
    };

    view.prototype.stage = function () {
        var self = this;

        self.$el.on('click.npseditorlinksSelectModule', '#treeContainer .item', function() {
            var $item = $(this),
                $anchors = self.$('#targetAnchor'),
                $select = self.$('#downloadSelect')
            ;

            if (self.$selection) {
                self.$selection.removeClass('selected');
            }
            $item.addClass('selected');
            self.$selection = $item;

            XMLSelect($select, 'load', {
                url: self.opts.path + 'moduleDownloadTypes.xml',
                data: {
                    moniker: $item.attr('moniker')
                }
            }).then(function () {
                var nbOptions = $select.find('option').length;
                self.$('#downloadType').toggle(nbOptions>1);
            });


            $anchors.hide();
            if (self.$selection) {
                var $xml = self.$('#anchorSelect');
                XMLSelect($xml, 'load', {
                    url: self.opts.path + 'documentAnchors.xml',
                    data: {moniker: $item.attr('moniker'), gsite: self.link.getProperty('site')}
                }).then(function () {
                    var nbOptions = $xml.find('option').length;
                    $anchors.toggle(nbOptions>1);
                });
            }

            self.editor.enableNext('select/module');
        });

        self.$('#treeContainer .item[moniker="'+self.link.getProperty('moniker')+'"]').click();

        return this;
    };
    view.prototype.unstage = function () {
        this.$el.off('.npseditorlinksSelectModule');
        return this;
    };

    view.prototype.commit = function () {
        var self = this,
            $downsel = self.$('#downloadSelect').find(':selected'),
            $anchorsel = self.$('#anchorSelect').find(':selected'),
            info = $downsel.data('info');

        if (!self.$selection) return self;
        if (!$downsel.length) return self;

        var displayMode = $downsel.val(),
            linker = info.linker,
            source = info.source,
            moniker = self.$selection.attr('moniker'),
            anchorId = $anchorsel.val() || ''
        ;

        var aParams = [
            'moniker=' + moniker,
            'site=' + self.link.getProperty('site')
        ];

        if (linker.indexOf('?')!=-1) {
            var strMoreParams=linker.substr(linker.indexOf('?')+1);
            linker=linker.substr(0,linker.indexOf('?'));

            var mParams=strMoreParams.split('&');
            for (var i=0;i<mParams.length;i++) {
                aParams.push(mParams[i]);
            }
        }

        var url='';

        var $precision = self.$selection.closest('li').children('select');
        if ($precision.length) {
            var value=$precision.val();
            if (linker==='none') {
                url = value;
            } else {
                aParams.push('precision='+value);
                url=linker+'?'+aParams.join('&');
            }
        } else {
            url=linker+'?'+aParams.join('&');
        }
        if (anchorId) {
            url+= "#"+anchorId;
        }

        self.link.setProperties({
            content: 'u',
            link: url,
            moniker: moniker,
            source: source,
            displayMode: $downsel.val()
        });

        return this;
    };
    return function(editor, opts) {
        return new view(editor, opts);
    }

})(window.jQuery, window._);